//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    baseSku: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      allSources: {
        renegades: ['https://player.vimeo.com/video/425197369', 'https://player.vimeo.com/video/427474759'],
        sierras: ['https://player.vimeo.com/video/274713983', 'https://player.vimeo.com/video/274840728'],
        classics3: ['https://player.vimeo.com/video/425201968', 'https://player.vimeo.com/video/427474525'],
        revolts: ['https://player.vimeo.com/video/244242844', 'https://player.vimeo.com/video/479841044'],
        snipers: ['https://player.vimeo.com/video/244242844', 'https://player.vimeo.com/video/479841044'],
        vanguards: ['https://player.vimeo.com/video/479841044', 'sungod18/vanguards-logo4.jpg']
      }
    }
  },
  computed: {
    sources () {
      return this.allSources[this.baseSku] || []
    }
  }
}
